module.exports = __webpack_public_path__ + "static/media/client9.d1fbac25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/client9.png
// module id = 129
// module chunks = 0